// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autocomplete-results{list-style-type:none;display:inline-block;padding-left:0}.autocomplete-result{float:left;clear:left;padding:5px 10px;border:1px solid grey;border-top:none;background-color:#fff;width:100%}.autocomplete-result:hover{background-color:#e9f3fc}", ""]);
// Exports
module.exports = exports;
